const readEnvVariable = (key: keyof typeof window.__env) =>
  process.env[key] || window.__env?.[key];

const publicUrl = readEnvVariable('PUBLIC_URL');

const isTruthy = (value: string | undefined) => value === 'true';

const isLocalDev = process.env.NODE_ENV !== 'production';

export const env = {
  apiUrl: `${readEnvVariable('REACT_APP_API_HOST')}/api`,
  apiUrlDefault: `${readEnvVariable('REACT_APP_API_HOST_DEFAULT')}/api`,
  assetsPrefix: publicUrl,
  publicUrl,
  gaMeasurementId: readEnvVariable('REACT_APP_GA_MEASUREMENT_ID'),
  enableDemo: isLocalDev || isTruthy(readEnvVariable('REACT_APP_ENABLE_DEMO')),
};
